/**
 * TodoDB 모듈 진입점
 *
 * TodoDB 인스턴스 관리 및 서비스 연동
 */

import { TodoDB } from './TodoDb'

// 전역 TodoDB 인스턴스
let todoDBInstance: TodoDB | null = null

/**
 * TodoDB 인스턴스 가져오기
 */
export const getTodoDB = (): TodoDB => {
  if (!todoDBInstance) {
    todoDBInstance = new TodoDB()
  }
  return todoDBInstance
}

/**
 * TodoDB 초기화
 */
export const initTodoDB = async (): Promise<boolean> => {
  try {
    const db = getTodoDB()
    const success = await db.init()

    if (success) {
      console.log('TodoDB initialized successfully')

      await db.ensureReady()
      // 기본 메타데이터만 설정
      // await db.setMetadata('dbInitialized', true)
      // await db.setMetadata('lastInitTime', Date.now())
    }

    return success
  } catch (error) {
    console.error('Failed to initialize TodoDB:', error)
    return false
  }
}

/**
 * TodoDB 연결 상태 확인
 */
export const isTodoDBReady = (): boolean => {
  return todoDBInstance ? todoDBInstance.isReady() : false
}

/**
 * TodoDB 인스턴스 종료
 */
export const closeTodoDB = (): void => {
  if (todoDBInstance) {
    todoDBInstance.close()
    todoDBInstance = null
  }
}

/**
 * DB 사용 여부 설정 확인
 */
export const isTodoDBEnabled = (): boolean => {
  // const todoSettings = settings.getValue('todo') || {}
  // return todoSettings.useIndexedDB === true
  return true
}

/**
 * DB 사용 여부 설정
 */
export const setTodoDBEnabled = (enabled: boolean): void => {
  // const todoSettings = settings.getValue('todo') || {}
  // todoSettings.useIndexedDB = enabled
  // settings.setValue('todo', todoSettings)

  if (enabled) {
    // DB가 활성화되면 초기화
    initTodoDB()
  } else {
    // DB가 비활성화되면 연결 종료
    closeTodoDB()
  }
}

// 모듈 export
export { TodoDB } from './TodoDb'
export type { TodoDBConfig } from './TodoDb'
